module.exports = __webpack_public_path__ + "static/6-markus-2ba7f9fc95b3ed011c525ec302cfcd2f.jpg";